module.exports = __webpack_public_path__ + "img/2.43853cbe.jpg";